import * as d3 from 'd3'

export default {
  methods: {

    draw_Milestones(selection, cht){

      let ms = this.milestone
      let msGroup = selection
      .append('g')
      .attr('id', `MILESTONES_${this.localId}`)
      .attr('transform', `translate(0 , ${0})`)


      this.milestone.list.filter(f=> f.inc.includes(this.current.id)).forEach(d=> {
        
        if(d.target <= this.current.start || d.target >= this.current.end) return

        let mstone = msGroup
        .append('g')
        .attr('transform', `translate(${this.gmx_BandToScale_Week(d.target)}, ${0})`)
        .attr('font-family', 'roboto').attr('cursor', 'default')

        mstone
        .append('line')
        .attr('x1', 0).attr('x2', 0)
        .attr('y1', 0).attr('y2', this.chart.height)
        .attr('stroke', '#757575').attr('stroke-width', .2)

        let y_ = 2
        if(ms.date.visible == 'Y') {
          mstone
          .append('text')
          .attr('id', `MS_${this.localId}`)
          .attr('transform',`translate(-2, ${y_}) rotate(-90)`)
          .attr('font-size', ms.date.tSize).attr('fill', ms.date.tColor).attr('text-anchor', 'end')
          .text(d.target)
          y_ += this.getNode(`#MS_${this.localId}`,'height')+2
        }

        if(ms.name.visible == 'Y') {
          mstone
          .append('text')
          .attr('transform',`translate(-2, ${y_}) rotate(-90)`)
          .attr('font-size', ms.name.tSize).attr('fill', ms.name.tColor).attr('text-anchor', 'end')
          .text(d.name)
        }
      })

    },
    
  }
}